export default __webpack_public_path__ + "static/media/handbra.48778ec9.jpg";